import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import loader from "../../methods/loader";
import ApiClient from "../../methods/api/apiClient";
import methodModel from "../../methods/methods";
import "./CardEnvelope.scss";
import BookOpenAnimation from "../../components/BookOpenAnimation";
import { IoChevronBack } from "react-icons/io5";

const CardEnvelope = () => {
    const [isEnvelopeOpen, setIsEnvelopeOpen] = useState(false);
    const [envelopeAnimation, setEnvelopeAnimation] = useState(false);
    const [detail, setDetail] = useState<any>();
    const { id } = useParams();
    const navigate = useNavigate();
    const token = sessionStorage.getItem("token")

    const getCardDetail = () => {
        loader(true)
        ApiClient.get(`payNow/detail?id=${id}`).then(res => {
            if (res.success) {
                setDetail(res?.data);
            }
            loader(false)
        });
    };

    useEffect(() => {
        getCardDetail()
    }, [])

    const handleEnvelopeClick = () => {
        setIsEnvelopeOpen(true)
    }

    useEffect(() => {
        const param_trigger_thank_you = false;

        function delay(ms: number) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        function adjustEnvelopeBasedOnScreenSize() {
            const envelope = document.getElementById('envelope');
            if (!envelope) return;
            const window_width = window.innerWidth;
            const envelope_width = envelope.offsetWidth;

            if (window_width < envelope_width) {
                const window_height = window.innerHeight;
                const envelope_height = envelope.offsetHeight;
                const scale = Math.min(window_width / envelope_width, window_height / envelope_height);

                const main = document.querySelector('main') as HTMLElement;
                if (main) {
                    main.style.width = `${window_width}px`;
                }
                envelope.style.transform = `translateX(0%) scale(${scale})`;
                envelope.style.transformOrigin = '0 0';
            }
        }

        async function runAnimations() {
            const envelope_front = document.getElementById('envelope_front');
            const envelope_back = document.getElementById('envelope_back');
            const flap_outside = document.getElementById('flap_outside');
            const flap_inside = document.getElementById('flap_inside');
            const card = document.getElementById('card');
            const envelope = document.getElementById('envelope');
            const envelope_rotator = document.getElementById('envelope_rotator');
            const main_canvas_area = document.getElementById('main_canvas_area');

            if (!envelope_front || !envelope_back || !flap_outside || !flap_inside || !card || !envelope || !envelope_rotator) return;

            envelope_front.classList.add('flipped');
            envelope_back.classList.add('flipped_almost_fully');

            await delay(1000);
            envelope_back.classList.add('flipped_fully');
            envelope_rotator.style.transform = 'rotate(90deg)';

            await delay(1000);
            card.style.display = 'block';
            flap_outside.classList.add('open_almost_fully');
            flap_inside.classList.add('open');

            await delay(500);
            flap_outside.classList.add('open_fully');

            await delay(1000);
            envelope_back.classList.add('slide');
            envelope_front.classList.add('slide');

            await delay(1500);
            envelope.style.display = 'none';
            setEnvelopeAnimation(true);
            if (main_canvas_area) {
                main_canvas_area.style.display = 'block';
            }
        }

        function animateEnvelope() {
            const envelope_front = document.getElementById('envelope_front');
            if (!envelope_front?.classList.contains('flipped') && isEnvelopeOpen) {
                runAnimations();
            }
        }

        adjustEnvelopeBasedOnScreenSize();

        if (param_trigger_thank_you) {
            const message_card_signer_modal = document.getElementById('message_card_signer_modal');
            const main_canvas_area = document.getElementById('main_canvas_area');

            if (main_canvas_area) {
                main_canvas_area.style.display = 'block';
            }
        } else {
            const envelope = document.getElementById('envelope');
            const envelope_front = document.getElementById('envelope_front');

            if (envelope) envelope.style.display = 'block';

            envelope_front?.addEventListener('click', animateEnvelope);

            setTimeout(() => {
                animateEnvelope();
            }, 3000);
        }

        window.addEventListener('resize', adjustEnvelopeBasedOnScreenSize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', adjustEnvelopeBasedOnScreenSize);
        };
    }, [isEnvelopeOpen]);

    return (
        <>
            <div className="images_bg overflow-hidden relative">
                {token &&
                    <button type="button" onClick={e => navigate(-1)} className="absolute top-5 left-5 flex items-center gap-1 bg-primary px-2 py-1 text-sm rounded-md"><IoChevronBack /> Back</button>
                }
                {envelopeAnimation ?
                    <div className="book-zoom-wrapper" style={{ display: "block", transform:"none", transformOrigin:"none" }}>
                        <BookOpenAnimation detail={detail} />
                    </div>
                    :
                    <div id="envelope" onClick={e => handleEnvelopeClick()} className="mx-0 sm:mx-auto">
                        <div id="envelope_rotator">
                            {/* Front Side */}
                            <div id="envelope_front" className="relative">
                                <div className="absolute top-[10px] right-[10px]">
                                    <img src="/assets/img/logos.jpg" className="h-32" alt="Stamp" />
                                </div>
                                <div id="envelope_to_person" className="text-black text-center">
                                    {detail?.recipient_name}
                                </div>
                            </div>
                            {/* Hidden Card */}
                            <div id="card" className="hidden">
                                <div id="card_inside">
                                    <div className="cover_photo_entries"></div>
                                    <div className="card_image relative">
                                        <img className="card_image max-w-[440px] max-h-[540px]" src={methodModel.noImg(detail?.cartDetail?.capturedImages?.[0])} style={{ position: "relative" }} />
                                    </div>
                                    <div className="unoccupied_cover_template_editable_text_areas"></div>
                                    <div className="cover_text_entries"></div>
                                </div>
                            </div>
                            {/* Back Side */}
                            <div id="envelope_back">
                                <div id="flap_outside">
                                    <div className="flap"></div>
                                </div>
                                <div id="flap_inside">
                                    <div className="flap"></div>
                                </div>
                                <div id="envelope_back_inside">
                                    <div id="left_side_cover"></div>
                                    <div id="right_side_cover"></div>
                                </div>
                                <div id="envelope_back_outside"></div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    );
};

export default CardEnvelope;